import { types } from './types';

const initialState = {
    list: [],
    history: {
        data: [],
        countPage: 1
    },
    events: {
        data: [],
        countPage: 1
    },
    view: {
        InformationPanel: false,
        FinanceReport: false,
        BonusesReport: false,
        JackpotReport: false,
        BalanceReport: false,
        EventReport: false,
        Jackpot: false,
        Tournament: false,
        Lottery: false,
        Referral: false,
        CreditLine: false,
        HistoryReplenishment: false,
        ReportProvider: false,
        GamesSearch: false,
        PaymentSystem: false,
        Withdrawals: false,
        WithdrawalsOperations: false,
        GamerReport: false,
        ReplenishmentReport: false,
        Gamer: false,
        Kyc: false,
        Bonuses: false,
        PersonalBonuses: false,
        PresentConfirmation: false,
        Freespin: false,
        CashierUsers: false,
        CashierReport: false,
        CashierFinance: false,
        CashierGroup: false,
        Support: false,
        SecurityAdmin: false,
        SecurityHistorySignin: false,
        SecurityHistoryEvent: false,
        ObjectOrganization: false
    }
}

export function adminReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LIST:
            return { ...state, list: action.payload };
        case types.SET_HISTORY:
            return { ...state, history: action.payload };
        case types.SET_EVENT:
            return { ...state, events: action.payload };
        case types.SET_VIEW:
            return { ...state, view: action.payload };
        default:
            return state
    }
}